<template>
  <Layer :visible="visible" :layerName="layerName">
    <div class="dlrLayer">
      <div class="dlrLayer-bottom dlrLayerBottom dlrQuotation">
        <div class="dlrLayerBottom-header dlrQuotation-header--verti">
          <h2 class="title">购车报价单</h2>
          <a class="dlrLayerBottom-close" @click="closeLay">关闭</a>
        </div>
        <div class="dlrLayerBottom-center">
          <div class="dlrQuotation-total">
            <div class="dlrQuotation-car">
              <div class="dlrQuotation-car--pic">
                <img :src="specInfo.ImageUrl" alt="" />
              </div>
              <div
                v-stat:click="buryPointClick"
                v-stat:show="buryPointShow"
                class="dlrQuotation-car--info"
                @click="openSeriesLay"
              >
                <p>{{ seriesName }} {{ specInfo.SpecName }}</p>
                <em></em>
              </div>
            </div>
          </div>
          <div class="dlrQuotation-detail">
            <div class="dlrQuotation-detail--nav">
              <ul>
                <li
                  v-stat:click="{
                    action: !isICSApp
                      ? 'dlr_baojia_page_quankuan_click'
                      : 'dlr_baojia_page_quankuan_b_click',
                    extend: {
                      channelId,
                      seriesId: salesSeriesId,
                      dealerId,
                    },
                  }"
                  v-stat:show="{
                    action: !isICSApp
                      ? 'dlr_baojia_page_quankuan_show'
                      : 'dlr_baojia_page_quankuan_b_show',
                    extend: {
                      channelId,
                      seriesId: salesSeriesId,
                      dealerId,
                    },
                  }"
                  :class="resetInfo.payType === 'full' ? 'current' : ''"
                  @click="changePayType('full')"
                >
                  <span>全款</span>
                </li>
                <li
                  v-stat:click="{
                    action: !isICSApp
                      ? 'dlr_baojia_page_daikuan_click'
                      : 'dlr_baojia_page_daikuan_b_click',
                    extend: {
                      channelId,
                      seriesId: salesSeriesId,
                      dealerId,
                    },
                  }"
                  v-stat:show="{
                    action: !isICSApp
                      ? 'dlr_baojia_page_daikuan_show'
                      : 'dlr_baojia_page_daikuan_b_show',
                    extend: {
                      channelId,
                      seriesId: salesSeriesId,
                      dealerId,
                    },
                  }"
                  :class="resetInfo.payType === 'loan' ? 'current' : ''"
                  @click="changePayType('loan')"
                >
                  <span>贷款</span>
                </li>
              </ul>
            </div>
            <div
              v-show="resetInfo.payType === 'full'"
              class="dlrQuotation-detail--item"
            >
              <div class="dlrQuotation-detail--left">
                <span class="dlrQuotation-detail--label">全款落地价预估</span>
                <em>(元)</em>
                <!-- <div class="dlrQuotation-detail--tips">
                  <i class="icon-qa_gray"></i>
                  <p class="iconPop popTop">
                    <span
                      >一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十</span
                    >
                  </p>
                </div> -->
              </div>
              <div class="dlrQuotation-detail--card">
                <p class="dlrQuotation-detail--base-text font-orange">
                  {{ priceListResult.fullLandingPrice }}
                </p>
              </div>
            </div>
            <div
              v-show="resetInfo.payType === 'loan'"
              class="dlrQuotation-detail--item"
            >
              <div class="dlrQuotation-detail--left">
                <span class="dlrQuotation-detail--label">提车落地价预估</span>
                <em>(元)</em>
                <!-- <div class="dlrQuotation-detail--tips">
                  <i class="icon-qa_gray"></i>
                  <p class="iconPop popTop">
                    <span
                      >一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十</span
                    >
                  </p>
                </div> -->
              </div>
              <div class="dlrQuotation-detail--card">
                <p class="dlrQuotation-detail--base-text font-orange">
                  {{
                    priceListResult &&
                    priceListResult.loan &&
                    priceListResult.loan.loanLandingPrice
                  }}
                </p>
              </div>
            </div>
            <div
              v-show="resetInfo.payType === 'loan'"
              class="dlrQuotation-detail--item"
            >
              <div class="dlrQuotation-detail--left">
                <span class="dlrQuotation-detail--label">贷款总花费预估</span>
                <em>(元)</em>
                <!-- <div class="dlrQuotation-detail--tips">
                  <i class="icon-qa_gray"></i>
                  <p class="iconPop popTop">
                    <span
                      >一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十</span
                    >
                  </p>
                </div> -->
              </div>
              <div class="dlrQuotation-detail--card">
                <p class="dlrQuotation-detail--base-text font-orange">
                  {{
                    priceListResult &&
                    priceListResult.loan &&
                    priceListResult.loan.allLoanCost
                  }}
                </p>
              </div>
            </div>
            <div class="dlrQuotation-detail--item">
              <div class="dlrQuotation-detail--left">
                <span class="dlrQuotation-detail--label">裸车价</span>
                <ins>指导价{{ zdPrice }}元</ins>
                <em>(元)</em>
              </div>
              <div class="dlrQuotation-detail--card">
                <p class="dlrQuotation-detail--base-text">
                  <input
                    v-model="carPrice"
                    class="dlrQuotation-detail--input"
                    v-input.int="carPrice"
                    type="text"
                    @blur="getPriceList(carPrice)"
                  />
                </p>
                <div class="dlrQuotation-detail--icon">
                  <em class="icon-edit__black"></em>
                </div>
              </div>
            </div>
            <div
              v-show="priceListResult.carSubsidy"
              class="dlrQuotation-detail--item"
            >
              <div class="dlrQuotation-detail--left">
                <span class="dlrQuotation-detail--label">购车补贴</span>
                <em>(元)</em>
                <!-- <em>(置换补贴3000元+新车补贴3000元)</em> -->
              </div>
              <div class="dlrQuotation-detail--card">
                <p class="dlrQuotation-detail--base-text">
                  -{{ priceListResult.carSubsidy }}
                </p>
              </div>
            </div>
            <div
              v-show="resetInfo.payType === 'loan'"
              class="dlrQuotation-detail--item"
            >
              <div class="dlrQuotation-detail--left">
                <span class="dlrQuotation-detail--label">首付金额</span>
                <em>(元)</em>
              </div>
              <div class="dlrQuotation-detail--card">
                <div class="dlrQuotation-detail--count-list">
                  <em>比例</em>
                  <ul>
                    <li
                      v-for="(value, key, index) in prepaymentTypeList"
                      :key="index"
                      v-stat:click="{
                        action: !isICSApp
                          ? 'dlr_baojia_page_shoufu_click'
                          : 'dlr_baojia_page_shoufu_b_click',
                        extend: {
                          channelId,
                          seriesId: salesSeriesId,
                          dealerId,
                          prepayment: value,
                        },
                      }"
                      v-stat:show="{
                        action: !isICSApp
                          ? 'dlr_baojia_page_shoufu_show'
                          : 'dlr_baojia_page_shoufu_b_show',
                        extend: {
                          channelId,
                          seriesId: salesSeriesId,
                          dealerId,
                          prepayment: value,
                        },
                      }"
                      class="dlrQuotation-detail--count-percent"
                      :class="
                        resetInfo.prepaymentType === value ? 'current' : ''
                      "
                      @click="changeMoneyType(value, 'prepaymentType')"
                    >
                      <span>{{ key }}</span>
                    </li>
                  </ul>
                </div>
                <p class="dlrQuotation-detail--base-text">
                  {{
                    priceListResult &&
                    priceListResult.loan &&
                    priceListResult.loan.prepayment
                  }}
                </p>
              </div>
            </div>
            <div
              v-show="resetInfo.payType === 'loan'"
              class="dlrQuotation-detail--count-list"
            >
              <em>比例</em>
              <ul>
                <li
                  v-for="(value, key, index) in prepaymentTypeList"
                  :key="index"
                  v-stat:click="{
                    action: !isICSApp
                      ? 'dlr_baojia_page_shoufu_click'
                      : 'dlr_baojia_page_shoufu_b_click',
                    extend: {
                      channelId,
                      seriesId: salesSeriesId,
                      dealerId,
                      prepayment: value,
                    },
                  }"
                  v-stat:show="{
                    action: !isICSApp
                      ? 'dlr_baojia_page_shoufu_show'
                      : 'dlr_baojia_page_shoufu_b_show',
                    extend: {
                      channelId,
                      seriesId: salesSeriesId,
                      dealerId,
                      prepayment: value,
                    },
                  }"
                  class="dlrQuotation-detail--count-percent"
                  :class="resetInfo.prepaymentType === value ? 'current' : ''"
                  @click="changeMoneyType(value, 'prepaymentType')"
                >
                  <span>{{ key }}</span>
                </li>
              </ul>
            </div>
            <div
              v-show="resetInfo.payType === 'loan'"
              class="dlrQuotation-detail--item"
            >
              <div class="dlrQuotation-detail--left">
                <span class="dlrQuotation-detail--label">月供金额</span>
                <em>(元)</em>
              </div>
              <div class="dlrQuotation-detail--card">
                <div class="dlrQuotation-detail--count-list">
                  <em>期限</em>
                  <ul>
                    <li
                      v-for="(value, key, index) in loanTypeForYearList"
                      :key="index"
                      v-stat:click="{
                        action: !isICSApp
                          ? 'dlr_baojia_page_qixian_click'
                          : 'dlr_baojia_page_qixian_b_click',
                        extend: {
                          channelId,
                          seriesId: salesSeriesId,
                          dealerId,
                          loanTypeForYear: value,
                        },
                      }"
                      v-stat:show="{
                        action: !isICSApp
                          ? 'dlr_baojia_page_qixian_show'
                          : 'dlr_baojia_page_qixian_b_show',
                        extend: {
                          channelId,
                          seriesId: salesSeriesId,
                          dealerId,
                          loanTypeForYear: value,
                        },
                      }"
                      :class="
                        resetInfo.loanTypeForYear === value ? 'current' : ''
                      "
                      class="dlrQuotation-detail--count-percent"
                      @click="changeMoneyType(value, 'loanTypeForYear')"
                    >
                      <span>{{ key }}期</span>
                    </li>
                  </ul>
                </div>
                <p class="dlrQuotation-detail--base-text">
                  {{
                    priceListResult &&
                    priceListResult.loan &&
                    priceListResult.loan.monthPay
                  }}
                </p>
              </div>
            </div>
            <div
              v-show="resetInfo.payType === 'loan'"
              class="dlrQuotation-detail--count-list"
            >
              <em>期限</em>
              <ul>
                <li
                  v-for="(value, key, index) in loanTypeForYearList"
                  :key="index"
                  v-stat:click="{
                    action: !isICSApp
                      ? 'dlr_baojia_page_qixian_click'
                      : 'dlr_baojia_page_qixian_b_click',
                    extend: {
                      channelId,
                      seriesId: salesSeriesId,
                      dealerId,
                      loanTypeForYear: value,
                    },
                  }"
                  v-stat:show="{
                    action: !isICSApp
                      ? 'dlr_baojia_page_qixian_show'
                      : 'dlr_baojia_page_qixian_b_show',
                    extend: {
                      channelId,
                      seriesId: salesSeriesId,
                      dealerId,
                      loanTypeForYear: value,
                    },
                  }"
                  :class="resetInfo.loanTypeForYear === value ? 'current' : ''"
                  class="dlrQuotation-detail--count-percent"
                  @click="changeMoneyType(value, 'loanTypeForYear')"
                >
                  <span>{{ key }}期</span>
                </li>
              </ul>
            </div>
            <div class="dlrQuotation-detail--item">
              <div class="dlrQuotation-detail--left">
                <span class="dlrQuotation-detail--label">商业保险</span>
                <em>(元)</em>
              </div>
              <div class="dlrQuotation-detail--card">
                <p class="dlrQuotation-detail--base-text">
                  {{
                    (priceListResult &&
                      priceListResult.commercialInsurance &&
                      priceListResult.commercialInsurance
                        .allCommercialInsurance) ||
                    0
                  }}
                </p>
              </div>
            </div>
            <div class="dlrQuotation-detail--item">
              <div class="dlrQuotation-detail--left">
                <span class="dlrQuotation-detail--label">必要花费</span>
                <em>(元)</em>
              </div>
              <div class="dlrQuotation-detail--card">
                <p class="dlrQuotation-detail--base-text">
                  {{
                    priceListResult &&
                    priceListResult.needCost &&
                    priceListResult.needCost.allNeedCost
                  }}
                </p>
              </div>
            </div>
            <div class="dlrQuotation-detail--cost">
              <ul>
                <li>
                  <span>购置税：</span>
                  <em>{{
                    priceListResult &&
                    priceListResult.needCost &&
                    priceListResult.needCost.purchaseTax
                  }}</em>
                </li>
                <li>
                  <span>车船税：</span>
                  <em>{{
                    priceListResult &&
                    priceListResult.needCost &&
                    priceListResult.needCost.usageTax
                  }}</em>
                </li>
                <li>
                  <span>交强险：</span>
                  <em>{{
                    priceListResult &&
                    priceListResult.needCost &&
                    priceListResult.needCost.trafficInsurance
                  }}</em>
                </li>
                <li>
                  <span>代办上牌：</span>
                  <em>{{
                    priceListResult &&
                    priceListResult.needCost &&
                    priceListResult.needCost.licenseTax
                  }}</em>
                </li>
              </ul>
            </div>
          </div>
          <div
            v-if="activity.length && activity.length === 2"
            class="dlrQuotation-coupon"
          >
            <div class="dlrQuotation-coupon-title">
              <p>店内优惠礼包</p>
            </div>
            <div class="dlrQuotation-coupon-list">
              <ul>
                <li>
                  <div class="dlrQuotation-coupon-item">
                    <div class="dlrQuotation-coupon-price">
                      <h3>
                        <em>¥</em
                        ><span>{{
                          activity[0] &&
                          activity[0].activity &&
                          activity[0].activity.commodityPrice
                        }}</span>
                      </h3>
                      <p>
                        {{
                          activity[0] &&
                          activity[0].activity &&
                          activity[0].activity.name
                        }}
                      </p>
                    </div>
                    <div class="dlrQuotation-coupon-name">
                      <span>试驾礼</span>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="dlrQuotation-coupon-item">
                    <div class="dlrQuotation-coupon-price">
                      <h3>
                        <em>¥</em
                        ><span>{{
                          activity[1] &&
                          activity[1].activity &&
                          activity[1].activity.commodityPrice
                        }}</span>
                      </h3>
                      <p>
                        {{
                          activity[1] &&
                          activity[1].activity &&
                          activity[1].activity.name
                        }}
                      </p>
                    </div>
                    <div class="dlrQuotation-coupon-name">
                      <span>到店礼</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div
            v-if="activity.length && activity.length === 1"
            class="dlrQuotation-coupon"
          >
            <div class="dlrQuotation-coupon-title">
              <p>店内优惠礼包</p>
            </div>
            <div class="dlrQuotation-coupon-list">
              <ul>
                <li>
                  <div class="dlrQuotation-coupon-item">
                    <div class="dlrQuotation-coupon-price">
                      <h3>
                        <em>¥</em
                        ><span>{{
                          activity[0] &&
                          activity[0].activity &&
                          activity[0].activity.commodityPrice
                        }}</span>
                      </h3>
                      <p>
                        {{
                          activity[0] &&
                          activity[0].activity &&
                          activity[0].activity.name
                        }}
                      </p>
                    </div>
                    <div class="dlrQuotation-coupon-name">
                      <span>{{
                        activity[0] &&
                        activity[0].activity &&
                        activity[0].activity.type === 6
                          ? '试驾礼'
                          : '到店礼'
                      }}</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="dlrLayer-mask" @click="closeLay"></div>
    </div>
  </Layer>
</template>
<script lang="js">
import { computed, ref, watch, defineComponent, onMounted, nextTick } from 'vue-demi';
import utils from '../../utils/util';
import store from '../../store'
import { ScrollSync } from '../../services/socketIO/scroll';
import queryParams from '../../services/pageQuery.service';
import layerManager from '../../services/layer.manager';
import eventBus from '@/services/eventBus.service';
import * as layerNames from '../../services/layerName';
import priceListActionSync from '../../services/actionSync/priceList.action.proxy';
import Layer from '../Layer.vue';
export const prepaymentTypeList = {
  '30%': 1,
  '40%': 2,
  '50%': 3,
  '60%': 4,
};
export const loanTypeForYearList = {
  '12': 1,
  '24': 2,
  '36': 3,
  '48': 4,
  '60': 5,
};

export default defineComponent({
  name: 'dlrQuotation',
  components: {
    Layer,
  },
  props: {
    isOpenDlrQuotation: {
      type: Boolean,
      default: false
    },
    layerName:{
      type:String,
      default:''
    }
  },
  setup(props) {
    const isICSApp = utils.isICSApp();
    function closeLay() {
      priceListActionSync.closeLay()
    }
    const visible = ref(true)
    const channelId = computed(()=>store.state.sales.vrSalesInfo.channelId)
    const dealerId = computed(()=>store.state.baseInfo.dealerId)
    const dealerSeriesList = computed(() => store.getters['dealer/seriesList'])
    const salesSeriesId = computed(() => store.state.dealer.salesSeriesId)
    const seriesName = computed(() => {
      let seriesInfo = dealerSeriesList.value.find(o => o.SeriesId === salesSeriesId.value);
      if (seriesInfo) {
        return seriesInfo.SeriesName;
      }
      return '';
    })
    const priceListResult = computed(() => {
      return store.state.priceList.priceListResult
    })
    const salesId = computed(() => {
      return store.state.sales.salesInfo.salesId
    })
    const activity = computed(() => {
      return store.state.priceList.activity
    })
    const carPrice = ref(0);
    watch(
      () => priceListResult.value.carPrice,
      (value) => {
        carPrice.value = value;
      },
      {
        immediate: true,
      },
    );
    function changePayType(type) {
      priceListActionSync.changePayType(type);
    }
    const specInfo = computed(() => {
      return store.state.priceList.specInfo
    })
    // 获取指导价
    const zdPrice = computed(() => specInfo.value.NewsPrice || specInfo.value.MinPrice)
    const cityId = computed(()=> store.state.baseInfo.cityId)
    const resetInfo = computed(() => {
      return store.state.priceList.resetInfo
    })
    // 切换首付金额比例
    function changeMoneyType(value, type) {
      const obj = {
        value,
        type,
        resetInfo:resetInfo.value,
        specInfo:specInfo.value,
        cityId:cityId.value,
        carPrice:carPrice.value
      }
      priceListActionSync.changeMoneyType(obj);
    }
    function getPriceList(value) {
      const obj = {
        value,
        specInfo:specInfo.value,
        cityId:cityId.value,
        resetInfo:resetInfo.value
      }
      priceListActionSync.getPriceList(obj);
    }

    function openSeriesLay() {
      priceListActionSync.openSeriesLay(salesSeriesId.value,specInfo.value.SpecId)
    }
    let timer = null
    watch(
      () => props.isOpenDlrQuotation,
      (value) => {
        if(isICSApp) { return; }
        if (store.state.hasWXshow) { return; }
        if (value) {
          if(isICSApp) { return; }
          timer = setTimeout(() => {
            priceListActionSync.openPriceListWeChatPhoneOrder()
            // layerManager.open(layerNames.TRANSPARENT_MASK, { propsData: { tips: '' } });
            layerManager.open(layerNames.USER_WE_CHAT_PHONE, {
              propsData: {
                dealerId: dealerId,
                seriesId: salesSeriesId.value,
                seriesName: seriesName.value,
                channelId: channelId.value,
                salesId:salesId.value,
                titleInfo:'添加微信，方便后续发送报价单变动信息',
                elementId: '2|1211004|897|18491|205767|304968',
              }
            });
            store.commit('setHasWXshow', true);
          }, 10 * 1000);
        }
      }, {
      immediate: true
    })
    eventBus.$on('closePriceListLay',()=>{
      // visible.value = false
      layerManager.close(props.layerName)
      clearTimeout(timer)
      timer = null
    })
    const buryPointClick = ref({
      action: !isICSApp ? 'dlr_baojia_page_genghuanchexi_click' : 'dlr_baojia_page_genghuanchexi_b_click',
      extend: {
        channelId:channelId.value,
        SeriesId: salesSeriesId.value,
        dealerId: dealerId,
      },
    });
    const buryPointShow = ref({
      action: !isICSApp ? 'dlr_baojia_page_genghuanchexi_show' : 'dlr_baojia_page_genghuanchexi_b_show',
      extend: {
        channelId:channelId.value,
        seriesId: salesSeriesId.value,
        dealerId: dealerId,
      },
    });
    onMounted(()=>{
      nextTick(()=>{
        new ScrollSync('dlrQuotationScroll', document.querySelector('.dlrLayerBottom-center'));
      })
    })
    return {
      seriesName,
      isICSApp,
      channelId,
      dealerId,
      carPrice,
      visible,
      priceListResult,
      salesSeriesId,
      resetInfo,
      activity,
      changePayType,
      zdPrice,
      changeMoneyType,
      getPriceList,
      closeLay,
      buryPointClick,
      buryPointShow,
      openSeriesLay,
      specInfo,
      prepaymentTypeList,
      loanTypeForYearList,
    }
  }
})
</script>
<style lang="scss">
@import './scss/dlrQuotation.scss';
</style>
